var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.formSubmitted($event)
        },
      },
    },
    [
      _vm.mainLoading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.mainLoading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Campaign Id",
                        "label-for": "campaign_id",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: "Campaign Id",
                          readonly: "",
                          name: "campaign_id",
                        },
                        model: {
                          value: _vm.emailId.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailId, "id", $$v)
                          },
                          expression: "emailId.id",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Campaign Name",
                        "label-for": "campaign_name",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: "Campaign Name",
                          name: "campaign_name",
                          readonly: "",
                        },
                        model: {
                          value: _vm.emailId.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailId, "name", $$v)
                          },
                          expression: "emailId.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: { label: "Start Date", "label-for": "start_date" },
                    },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "start_date",
                          placeholder: "Choose a date",
                          local: "en",
                          disabled: "",
                        },
                        model: {
                          value: _vm.emailId.startDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailId, "startDate", $$v)
                          },
                          expression: "emailId.startDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "End Date", "label-for": "end_date" } },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "end_date",
                          placeholder: "Choose a date",
                          local: "en",
                          "initial-date": "2024-06-16",
                          disabled: "",
                        },
                        model: {
                          value: _vm.emailId.endDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailId, "endDate", $$v)
                          },
                          expression: "emailId.endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Email Template",
                        "label-for": "email_template",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.emailtemplatelist, disabled: "" },
                        model: {
                          value: _vm.emailId.emailTemplate.templateId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.emailId.emailTemplate,
                              "templateId",
                              $$v
                            )
                          },
                          expression: "emailId.emailTemplate.templateId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Subject", "label-for": "subject" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: "Subject",
                          name: "subject",
                          readonly: "",
                        },
                        model: {
                          value: _vm.emailId.emailTemplate.subject,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailId.emailTemplate, "subject", $$v)
                          },
                          expression: "emailId.emailTemplate.subject",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Segment", "label-for": "segment" } },
                    [
                      _c("v-select", {
                        attrs: {
                          dir: _vm.$store.state.appConfig.isRTL ? "rtl" : "ltr",
                          multiple: "",
                          label: "itemTitle",
                          options: _vm.segmentOptions,
                          disabled: "",
                        },
                        model: {
                          value: _vm.selectedSegments,
                          callback: function ($$v) {
                            _vm.selectedSegments = $$v
                          },
                          expression: "selectedSegments",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Status", "label-for": "status" } },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.statusOptions, disabled: "" },
                        model: {
                          value: _vm.emailId.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailId, "status", $$v)
                          },
                          expression: "emailId.status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "SMTP Setting",
                        "label-for": "email_smtp",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "SMPT setting",
                          vid: "SMPT Setting",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-select", {
                                    attrs: {
                                      state: errors.length > 0 ? false : null,
                                      options: _vm.smtp,
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.emailId.smtpSettingId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.emailId,
                                          "smtpSettingId",
                                          $$v
                                        )
                                      },
                                      expression: "emailId.smtpSettingId",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3442631500
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.emailId.status === "SCHEDULED"
                ? _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Scheduled Published Date",
                            "label-for": "scheduledPublishedDate",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              id: "scheduledPublishedDate",
                              local: "en",
                              disabled: "",
                            },
                            model: {
                              value:
                                _vm.emailId.campaignDrafts[0]
                                  .scheduledPublishedDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.emailId.campaignDrafts[0],
                                  "scheduledPublishedDate",
                                  $$v
                                )
                              },
                              expression:
                                "emailId.campaignDrafts[0].scheduledPublishedDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("b-form-group", {
                    attrs: {
                      label: "Email Content",
                      "label-for": "email_content",
                    },
                  }),
                  _c("quill-editor", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.emailId.emailTemplate.body,
                      callback: function ($$v) {
                        _vm.$set(_vm.emailId.emailTemplate, "body", $$v)
                      },
                      expression: "emailId.emailTemplate.body",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }